import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export interface BackLinkProps {
  /** Ścieżka React Router. */
  to?: string;
  /** Alternatywnie do `to` - custom handler (np. navigate(-1)). */
  onClick?: () => void;
  label?: ReactNode;
  className?: string;
}

/**
 * Link powrotu na rodzicielską stronę. Jeden wzór dla całej aplikacji
 * (wcześniej było kilka wariantów: "← Wróć do", "Powrót do", arrow jako
 * znak "<" vs ikona). Używaj nad <PageHeader>.
 *
 * Default label: "Wróć".
 */
export function BackLink({ to, onClick, label = 'Wróć', className }: BackLinkProps) {
  const cls = [
    'inline-flex items-center gap-1.5 text-sm text-text-muted hover:text-text-primary transition-colors duration-fast mb-3',
    className,
  ].filter(Boolean).join(' ');

  const content = (
    <>
      <ArrowLeft className="w-3.5 h-3.5" />
      <span>{label}</span>
    </>
  );

  if (to) {
    return <Link to={to} className={cls}>{content}</Link>;
  }
  return (
    <button type="button" onClick={onClick} className={cls}>
      {content}
    </button>
  );
}
